import { Injectable, Inject } from '@angular/core';
import { Location } from '@angular/common';
import { BehaviorSubject, Subject } from 'rxjs';
import { ApiLibs } from '@libs/config/api-library';
import { PassInfo } from '@models/pass-info-model';
import { Base64Decode, Base64DecodePlainObjByFilter} from '@core/utils/help'
import { FactoryService } from './factory.service';
import { AccountService } from './account.service';
import { ComActionService } from './com-action.service';
import { funcTypeMap } from '@core/libs/config/profile-mapping';
import { Base64 } from 'js-base64';
import { AcpService } from './acp.service';
import { RFactoryService } from '@services/realname/r-factory.service';
import { ComRouteService } from './com-route.service';
import { TrackingInterface, SH_TRACKING} from '@libs/tracking';
import { Title } from '@angular/platform-browser';
import { PlatformDetect } from '@libs/platform/platform-detect';
import { ComSubService } from './com-sub.service';
import { ProfileInfo } from '@models/user-info-model';

@Injectable({
  providedIn: 'root'
})
    
export class CommonService {
  private language: string;
  public pubConfigs: any;
  public showReminderSub = new BehaviorSubject<boolean>(false);
  public showForgetSub = new BehaviorSubject<boolean>(false);
  public clearnPhoneSub = new BehaviorSubject<boolean>(false);
  public showErrorSub = new BehaviorSubject<boolean>(false);
  public showCaptchaSub = new BehaviorSubject<boolean>(false);
  public triggerCaptchaSub = new BehaviorSubject<boolean>(false);
  public resendPinSub = new BehaviorSubject<boolean>(false);
  public sendVoicePinSub = new BehaviorSubject<boolean>(false);
  public openVoicePin: boolean = false; //use for control open Voice function
  public loginVoiceToggle: boolean = false; //use for check Voice function toggle in login&register flow
  public comVoiceToggle: boolean = false; //use for check Voice function toggle in common flow

  public phoneChecked = new Subject<boolean>();
  public phoneCheckedSub = this.phoneChecked.asObservable(); // 完成手机号格式校验订阅
  public phoneChecking: boolean = false; // 是否正在进行手机号格式校验

  public nameChecked = new Subject<boolean>();
  public nameCheckedSub = this.nameChecked.asObservable(); // 完成姓名敏感词检验订阅
  public nameChecking: boolean = false; // 是否正在进行姓名敏感词校验

  private haveUserInfo: boolean = false; //check have userinfo no not
  public refreshed: boolean = false;
  public virPhoneToggle: boolean = false;  //virtual-phone toggle
  public virtualPhone: boolean = false; // virtural-phone flag
  public thirdBindingToggle: boolean = false; // third binding toggle
  public appQRToggle: boolean = false; // qrCode toggle in app
  public minipQRToggle: boolean = false; // qrCode toggle in minip
  
  public lgType: string; //login type
  public areaNum: string; 
  public mobile: string;
  public email: string;
  public password: string;
  public pinCode: string;
  public passInfo: PassInfo;

  public inviteCode: string; // for csp flow
  public captchaVerifyForApp:boolean = false; // captcha verify or easy-login app
  
  constructor(
    private location: Location,
    private title: Title,
    private platform: PlatformDetect,
    private factorySer: FactoryService,
    private acctSer: AccountService,
    private comActSer: ComActionService,
    private acpSer: AcpService,
    private rFactorySer: RFactoryService,
    private comRoute: ComRouteService,
    private comSubSer: ComSubService,
    @Inject(SH_TRACKING) private trackIn: TrackingInterface,
  ) {
    this.initLanguage();
  }

  private async initLanguage() { 
    this.language = await this.factorySer.getLanguage();
  }

  /* check the save area height in app to deal with some invaild UI style
     key = sat / sab
  */
  public checkSafeArea(key?: string) { 
    if (key) {
      const tmpTB =  parseInt(getComputedStyle(document.documentElement).getPropertyValue(`--${key}`))
      console.log('checkSafeArea tmpTB..', tmpTB);
      return tmpTB;
    } else { 
      const tmpT = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sat')); //safe-top
      const tmpB = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sab')); //safe-bottom
      console.log('checkSafeArea..', `sat:${tmpT}  sab:${tmpB}  satb:${tmpT + tmpB}`);
      return { sat: tmpT, sab: tmpB, satb: tmpT + tmpB } ;
    }
  }

  public setTitle(key: string) { 
    if (this.platform.isWx()) { 
      this.title.setTitle(this.acpSer.getAcpText(key) || '');
    }
  }

  //get ETCD configs
  async getConfigs(){
    const resp = await this.acctSer.fetchConfigs();
    if (resp?.code === '0' && resp?.data) {
      const tingYun = resp.data?.tingYun;
      const filterKeys = ["id","key","token"]; // SHDRP-374278
      if(tingYun) {
        resp.data.tingYun = Base64DecodePlainObjByFilter(tingYun,...filterKeys)
      }
 
      this.factorySer.pubConfigs = resp.data;
      this.pubConfigs = resp.data;
      return resp.data;
    } else {
      console.log('getConfigs error', resp);
      if (resp?.name === this.factorySer.timeOutErr) {
        console.log('timeOutErr error..', resp);
        this.showErrorSub.next(true);
      } else if(resp) {
        console.log('limit error..', resp);
      } else { 
        return null;
      }
    }
  }

  // get country call codes
  async getCountryCallList() {
    const tmpKey = `countryList.${this.language}`;
    const list = this.factorySer.getSessionInfo(tmpKey, true);
    if (list) {
      this.factorySer.countries = list;
      return list;
    } 
    const resp = await this.acctSer.getCountryCallCodes(); 
    if (resp?.code === '0' && resp?.data) {
      this.factorySer.countries = resp.data;
      sessionStorage.setItem(tmpKey, JSON.stringify(resp.data));
      return resp.data;
    } else {
      console.log('getCountryList error', resp);
      return null;
    }
  }

  async getProvinceList() {
    const tmpKey = `provinces.${this.language}`;
    const list = this.factorySer.getSessionInfo(tmpKey, true);
    if (list) return list;
    const resp = await this.acctSer.getProvinces(); 
    if (resp?.code === '0' && resp?.data) {
      this.factorySer.provinces = resp.data;
      sessionStorage.setItem(tmpKey, JSON.stringify(resp.data));
      return resp.data;
    } else {
      console.log('getProvinceList error', resp);
      return null;
    }
  }

  // get country regions
  async getCountryRegions() {
    const tmpKey = `countryRegionList.${this.language}`;
    const list = this.factorySer.getSessionInfo(tmpKey, true);
    if (list) return list;
    const resp = await this.acctSer.getCountryRegions(); 
    if (resp?.code === '0' && resp?.data) {
      sessionStorage.setItem(tmpKey, JSON.stringify(resp.data));
      return resp.data;
    } else {
      console.log('getCountryRegions error', resp);
      return null;
    }
  }
  
  /*check phone/email/password/name validate with validtype
    validtype = MOBILE_FORMAT | MOBILE_EXIST | EMAIL_FORMAT | PASSWORD_FORMAT | VIRTUAL_MOBILE | NAME_FORMAT_AND_SENSITIVE | VIRTUAL_MOBILE_AND_FORMAT
    checkType = phone | email | password | name 
  */
  async validateCheck(params: any, validType: string, checkType: string, logined?: boolean): Promise<any> { 
    params['validateType'] = validType;
    this.factorySer.setLimitType('toast');
    const res = await this.acctSer.validateVerify(params, logined);
    if(!res) { // 触发tyk限流429
      this.comSubSer.refreshLoading(false);
      return null;
    }
    const resCode = res?.code;
    this.comSubSer.refreshLoading(false);
    if (checkType === 'name' || checkType === 'password') {
      return resCode;
    } else { 
      if (resCode === '0') {
        switch (checkType) { 
          case 'phone':
            //clear virtualPhone cache when phone changed and valid
            if (this.virtualPhone) {
              this.clearVirtualPhone();
            }
            return { valid: true, code: resCode };
          case 'email':
            return { valid: true, code: resCode };
          default:
            return true;
        }
      } else { 
        switch (checkType) { 
          case 'phone':
            return this.checkPhone(resCode);
          case 'email':
            return { valid: false, code: resCode };
          default:
            this.showErrorSub.next(true);
            break;
        }
      }
    }
  }
  
  private checkPhone(resCode: any): any { 
    let result = { valid: true, code: resCode};
    switch (resCode) {
      case '0304BP006': //format err
        result.valid = false;
        break;
      case '0304BP007':  //virtual phone handle
        if (this.virPhoneToggle) { 
          this.virtualPhone = true;
          sessionStorage.setItem('showVirtualPhonePop', 'true');
        }
        break;
      case '0304BBG03': //phone aleady exist when update-phone
        this.factorySer.phoneExist = true;
        break;
      case '0304BP011': //entered phone not match with old-phone
        this.factorySer.phoneNoMatch = true;
        break;
      case '0304AP001': // request params error
        this.factorySer.setSinglePop();
        result.valid = false;
        console.log('param err...');
        break;
      default:
        break;
    }
    return result;
  }

  clearVirtualPhone() { 
    this.virtualPhone = false;
    sessionStorage.removeItem('showVirtualPhonePop');
  }
    
  // check for login pass-info (like: pin-code passed info, virtual-phone check)
  public async captchaPassed(info: {params:string}) { 
    if(this.captchaVerifyForApp){
      this.captchaVerifyForApp = false;
      if (this.factorySer.isAbleVersion('captchaSuccessVer')) {
        const res = await this.comActSer.tiggerAppCaptchaVerify(info.params)
        if(res?.resultCode === 0) {
          if (window.DisneyJSBridge) {
            window.DisneyJSBridge.call('closeHybridView', {}, (res) => {
              console.log('closeHybridView..', res);
            })
          }
        }
      }
      return
    }

    // check foreign phone is virtual-Phone
    sessionStorage.setItem('captchaPssed', 'true');
    const isVirtualPhone = this.checkVirtualPhone();
    if (!isVirtualPhone) { 
      const pinType = this.factorySer.getPinType();
      if (!this.mobile && pinType !== 'deleteAcct' && pinType !== 'forgetPwdEmail') { //use check thre is no mobile after pasge refreshed
        const passInfo = pinType === 'phonePin'? this.factorySer.getSessionInfo('logInfo', true) : JSON.parse(sessionStorage.getItem('passInfo'));
        this.mobile = passInfo?.mobile;
        this.areaNum = passInfo?.areaNum;
      }
      if (!this.email) { 
        const passInfo = JSON.parse(sessionStorage.getItem('passInfo'));
        this.email = passInfo?.email;
      }
      /** check CN phone is virtual-Phone ( since input phone will not trigger API to check)
       * check function flow: phonePin(login) | phoneUpdate
       */
      if ((pinType === 'phonePin' || pinType === 'legacyPhonePin'|| pinType === 'cspPhonePin') && this.areaNum === '86,CN') {
        const param = {
          mobileAreaNum: this.areaNum?.split(',')[0],
          mobile: this.mobile
        }
        const validateFlag = await this.validateCheck(param, 'VIRTUAL_MOBILE_AND_FORMAT', 'phone');
        if (validateFlag) { //check info is validate
          const isVirtualPhone = this.checkVirtualPhone();
          if (!isVirtualPhone) { 
            this.checkPin(info, pinType);
          }
        } 
      } else { 
        this.checkPin(info, pinType);
      }
    }
  }
  public  captchaClose() { 
    if(this.captchaVerifyForApp && this.platform.isApp()){
        this.captchaVerifyForApp = false;
        if (window.DisneyJSBridge) {
          window.DisneyJSBridge.call('closeHybridView', {}, (res) => {
            console.log('closeHybridView..', res);
          });
        }
    }
  }

  private checkVirtualPhone(): boolean { 
    const flag = this.virtualPhone || sessionStorage.getItem('showVirtualPhonePop') === 'true';
    if (flag) {
      setTimeout(() => { 
        this.showReminderSub.next(true);
      }, 10);
      return true;
    } else { 
      return false;
    }
  }

  private getPassInfo(info: any, pinType: string): any { 
    const noInfo = !this.mobile && (pinType === 'phonePin' || pinType === 'phonePwd') ||
      !this.email && pinType === 'emailPwd';
    if (noInfo) { 
      const logInfo = this.factorySer.getSessionInfo('logInfo', true);
      this.mobile = logInfo?.mobile;
      this.areaNum = logInfo?.areaNum;
      this.email = logInfo?.email;
    }
    let passInfo: PassInfo = {
      capId: info.capId,
      captchaParams: info.params,
      areaNum: this.areaNum || this.factorySer.userInfo?.areaNumber,
      mobile: this.mobile || this.factorySer.userInfo?.mobile,
      email: this.email,
      loginType: pinType.toLocaleLowerCase().includes('email')? 0: 1,
      pinCode: this.pinCode,
      updatePhone: pinType === 'phoneUpdate'? this.mobile : null
    }

    // there is not pinType check (when refresh page)
    if (pinType) {
      sessionStorage.setItem('passInfo', JSON.stringify(passInfo));
    } else { 
      if (!this.mobile) {
        const tmpInfo = JSON.parse(sessionStorage.getItem('passInfo'));
        this.mobile = tmpInfo?.mobile;
        this.areaNum = tmpInfo?.areaNum;
        passInfo.mobile = tmpInfo?.mobile;
        passInfo.areaNum = tmpInfo?.areaNum;
      }
    }
    this.passInfo = passInfo;
    return passInfo;
  }

  /* 
    passInfo is params for passed pin-code and captcha 
  */
  async checkPin(info: any, pinType: string) {
    let body = {};
    let res;
    const passInfo = this.getPassInfo(info, pinType);
    this.factorySer.setLimitType('toast');
    if (pinType === 'deleteAcct') {
      body = { params: info?.params };
      res = await this.acctSer.triggerLoggedPin(body, 'send');
    } else { 
      //set tracking only for login page get_verify_code
      const isLoginPage = (/login/).test(window.location.pathname);
      if (pinType === 'phonePin' && isLoginPage) { 
        this.trackIn.setTracking({
          event: 'get_verify_code',
          screen_type: 'register_and_login',
          page_name: 'tools/login/mobile'
        }, true);
      }
      body = this.getSendPinBody(pinType, passInfo);
      res = await this.acctSer.triggerPinInfo(body, 'send');
    }
    if (pinType && res) { 
      if (res?.code === '0' && res?.data) {
        this.factorySer.pinInfo.countDownSeconds = res?.data?.countDownSeconds;
        sessionStorage.setItem('passInfo', JSON.stringify(passInfo));
        const pinMode = this.factorySer.pinMode;
        if (this.factorySer.resendPin) {
          this.resendPinSub.next(true);
        } else { 
          if (pinType === 'phonePin') {
            this.factorySer.setLoginStatus(false); //remove login state when re-login
          }
          sessionStorage.setItem('pinType', pinType);
          /* 
            pinMode is 'Voice': just show toast
            pinMode is 'SMS': routing to pincode page
          */
          if (pinMode === 'Voice') {
            this.sendVoicePinSub.next(true);
          } else {
            if (!pinMode) this.factorySer.setPinMode('SMS');
            this.comRoute.route('pin-code');
          }
        }
        //set track and toast only for get Voice-pin success
        if (pinMode === 'Voice') { 
          this.voiceSuccessTrack(pinType);
        }
      } else{
        switch (res?.code) {
          case '0305BB000': //pincode-stop util valid time
            const timer = res?.data?.countDownSeconds;
            this.factorySer.popMsg = timer ? this.getPinTimesErrMsg(timer) : this.acpSer.getAcpText('Profile.Common.Popup.Desc.Global.Err');
            this.factorySer.descPip = false;
            if (pinType === 'forgetPwdEmail' || pinType === 'forgetPwdPhone') {
              this.factorySer.popTitle = 'Profile.Common.ForgetPwd.Label';
            }
            break;
          default:
            this.factorySer.popMsg = 'Profile.Common.Popup.Desc.Global.Err';
            break;
        }
        this.factorySer.showSinglePop = true;
      }
    }
  }

  private voiceSuccessTrack(pinType: string) { 
    this.trackIn.setTracking({
      event: 'popup_view',
      screen_type: this.factorySer.getScreenType(pinType),
      page_name: this.factorySer.getPageName(pinType),
      popup_name: 'get_audio_verification_succsess'
    });
    this.factorySer.setToast(true, '2rem', null, 'Profile.PinCode.Voice.Toast.SendSuccess');
  }

  /*
    functionType is use for check diff function type
    functionType = GUEST_LOGIN_MOBILE / DELETE_ACCOUNT_MOBILE / FORGOT_PASSWORD_EMAIL / FORGOT_PASSWORD_MOBILE / MOBILE_UPDATE / GUEST_LOGIN_EMAIL
  */
  public getSendPinBody(pinType: string, passInfo?: any): any { 
    const info = passInfo || JSON.parse(sessionStorage.getItem('passInfo'));
    if (pinType === 'deleteAcct') {
      return { params: info?.captchaParams };
    } else { 
      let body = {
        functionType: funcTypeMap.get(pinType),
        params: info?.captchaParams 
      };
      switch (pinType) { 
        case 'forgetPwdEmail':
          body['email'] = this.email || info?.email;
          break;
        default: //  phonePin | legacyPhonePin | cspPhonePin
          const areaNum = this.areaNum || info?.areaNum;
          body['mobileAreaNum'] = areaNum?.split(',')[0];
          body['mobile'] = this.mobile || info?.mobile;
          break;
      }
      return body;
    }
  }

  public setPinCode(pin: string) { 
    this.pinCode = pin;
    let passInfo: PassInfo = this.passInfo || this.factorySer.getSessionInfo('passInfo', true);
    if (passInfo) {
      passInfo.pinCode = Base64.encode(pin);
    } else { 
      passInfo = { pinCode: Base64.encode(pin) };
    }
    this.passInfo = passInfo;
    sessionStorage.setItem('passInfo', JSON.stringify(passInfo));
  }

  async verifyPin(): Promise<any> {
    const pinType = this.factorySer.getPinType();
    const passInfo = this.passInfo || JSON.parse(sessionStorage.getItem('passInfo'));
    let params = {
      pinCode: this.pinCode || Base64.decode(passInfo?.pinCode)
    };
    // delete account body only need pinCode
    if (pinType === 'deleteAcct') { 
      return this.acctSer.triggerLoggedPin(params, 'verify');
    } else { 
      params['functionType'] = funcTypeMap.get(pinType);
      const resetType = this.factorySer.getResetType();
      if (pinType === 'phonePin' || pinType === 'phoneUpdate' || pinType === 'legacyPhonePin'|| pinType === 'cspPhonePin' || resetType === 'phoneVerify') {
        const areaNum = this.areaNum || passInfo?.areaNum;
        params['mobileAreaNum'] = areaNum.split(',')[0];
        params['mobile'] = this.mobile || passInfo?.mobile;
      } else {
        params['email'] = this.email || passInfo?.email;
      }
      return this.acctSer.triggerPinInfo(params, 'verify');
    }
  }

  async getUserInfo(returnFlag?: boolean): Promise<any>  { 
    if (!this.haveUserInfo) {
      this.haveUserInfo = true;
      // 2s内防止重复调用，两秒后重置haveUserInfo
      let timmer = setTimeout(() => { 
        this.haveUserInfo = false; 
        clearTimeout(timmer);
        timmer = null;
      }, 2000);
      const resp = await this.acctSer.triggerUserInfo();
    if (resp && resp?.code === '0' && resp?.data) {
        const tmpProfile = Base64Decode(resp?.data);
        this.factorySer.userInfo = tmpProfile;
        this.factorySer.setSWID(tmpProfile?.swid);
        this.setLogined(true);
        console.log('getUserInfo setted factorySer userInfo..');
        this.acctSer.getOaFans();
        this.acctSer.getApHolder();
        // 路由守卫返回true, 其他业务调用返回数据
        return returnFlag? true: tmpProfile;
      } else if(!resp && returnFlag) {
        console.log('interceptor handle getUserInfo err:', resp);
        this.setLogined(false);
        return true;
      } else {
        console.log('getUserInfo un-login..', resp);
        this.setLogined(false);
        return false;
      }
    } else { 
      return this.factorySer.userInfo;
    }
  }

  public getUserName(info: ProfileInfo): string { 
    const firstN = info?.firstName;
    const lastN = info?.lastName;
    const nameZH = `${lastN || ''} ${firstN || ''}`;
    const nameEN = `${firstN || ''} ${lastN || ''}`;
    return (firstN || lastN) ? (this.language === 'en' ? nameEN : nameZH) : null;
  }

  private setLogined(logined: boolean) {
    if (this.factorySer.notToLogin) return logined; //notToLogin use for: dont save login state when init member modules

    this.factorySer.setLoginStatus(logined);
    if (!logined) { 
      this.factorySer.clearLogInfo();
    }
  }

  /** 
   * returnFlag: control return to previous page
   * successToast: control show success toast when update success
   * showFailToast: control show failure toast when update success
  */
  async updateProfile(key: string, params: any, returnFlag: boolean = true, showSuccessToast: boolean = true, showFailToast: boolean = true): Promise<any> { 
    let path;
    switch (key) { 
      case 'avatar':
        path = ApiLibs.changeAvatar;
        break;
      case 'name':
        path = ApiLibs.changeName;
        break;
      case 'birth':
        path = ApiLibs.setBirthday;
        break;
      case 'region':
        path = ApiLibs.changeRegion;
        break;
      case 'preference':
        path = ApiLibs.changePreference;
        break;
      case 'phone':
        path = ApiLibs.changePhone;
        break;
      case 'email':
        path = ApiLibs.changeEmail;
        break;
      case 'addPwd':
        path = ApiLibs.addPassword;
        params.password = this.factorySer.encryptCode(params?.password);
        break;
      case 'changePwd':
        path = ApiLibs.changePassword;
        params.oldPassword = this.factorySer.encryptCode(params?.oldPassword);
        params.newPassword = this.factorySer.encryptCode(params?.newPassword);
        break;
      case 'resetPwd':
        path = ApiLibs.resetPassword;
        params.password = this.factorySer.encryptCode(params?.password);
        break;
      default:
        break;
    }
    this.factorySer.setLimitType('toast');
    const resp = await this.acctSer.doUpdateProfile(path, params, key);
    this.comSubSer.refreshLoading(false);
    if(resp) {
      if (key !== 'resetPwd') { 
        //check sensitive word err for update-name
        if (key === 'name' && resp?.code === '0304BP003') { 
          return { code: resp.code };
        } 
        if (returnFlag) this.location.back();
        const success = resp?.code === '0';
        if (success) {
          this.factorySer.userInfo = null; //clear session userinfo when update success
          if (showSuccessToast) this.factorySer.setToast(true);
        } else { 
          //email exist error (0305BBG15) don't need to show fail toast ; 
          if (key === 'email') { 
            showFailToast = (resp?.code !== '0305BBG15'); 
          } 
          if (showFailToast) { 
            this.factorySer.setToast(false, '2rem', null, 'Profile.Common.Toast.UpdateInfo.Failure');
          }
        }
      }
      return resp;
    }
  }

  /**
   * mask as '*'
   * Phone:
   * phone.length > 10: mask except the first three and last four number
   * phone.length <= 10: mask except the first two and last three number
   *
   * Email: ( mask the characters before first '@')
   * characters.length < 3, mask except the first characters
   * characters.length >= 3, mask except the first and last 
  */
  getMaskValue(value: string, key: string = 'phone'): string {
    if (value) { 
      const repResult = (_, pre, midle, suf) => (pre + '*'.repeat(midle.length) + suf);
      switch (key) { 
        case 'phone':
          const rep1 = value.length < 10 ? /^(\d{2})(\d+)(\d{3})$/ : /^(\d{3})(\d+)(\d{4})$/;
          return value.replace(rep1, repResult);
        case 'email':
          //set email value as: {{Arr[0]}}@{{Arr[1]}} ======> eg: XXX@XX.com => Arr[0]=XXX, Arr[1]=XX.com
          const Arr = value.split('@');
          let emailPre = '';
          if (Arr[0].length < 3) {
            emailPre = Arr[0].replace(/^(.).$/, '$1*');
          } else { 
            const rep2 = /^(.{1})(.+)(.{1})$/;
            emailPre = Arr[0].replace(rep2, repResult);
          }
          return `${emailPre}@${Arr[1]}`;
        default:
          break;
      }
    } else {
      return '';
    }
  }

  // timer is countDownSeconds (unit in seconds) from sen-pinco API
  getPinTimesErrMsg(timer: number) { 
    const tmpT = timer > 0? Math.ceil(timer / 60): 0; // display the time rounded up in minutes
    return this.acpSer.getAcpText('Profile.PinCode.Tips.Times.Err').replace('[T]', tmpT);
  }

  async getCountryRegionOpts() {
    const countryRegionOptsKey = `countryRegionOpts.${this.language}`;
    let countryRegionOpts = this.factorySer.getSessionInfo(countryRegionOptsKey, true);
    const popularLabel = this.acpSer.getAcpText('Profile.Common.ChooseCountry.Label.Popular');
    const allLabel = this.acpSer.getAcpText('Profile.Common.ChooseCountry.Label.All');
    const privanceKey = `provinces.${this.language}`;
    const privance = this.factorySer.getSessionInfo(privanceKey, true);
    if (privance && countryRegionOpts && countryRegionOpts.length) {
      return countryRegionOpts;
    }
    countryRegionOpts = [];
    const regions = await this.getProvinceList();
    const countries = await this.getCountryRegions();
    let popularList = regions ? regions.popularList : null;
    let sortedList = regions ? regions.sortedList : null;
    const regionsOpts = [];
    // 热门省份
    if (popularList && popularList.length) {
      popularList.forEach(item => {
        regionsOpts.push({
          label: item.name,
          value: item.code,
          optGroup: {
            label: popularLabel
          }
        })
      });
    }
    // 全部省份
    if (sortedList && sortedList.length) {
      sortedList.forEach(item => {
        regionsOpts.push({
          label: item.name,
          value: item.code,
          optGroup: {
            label: allLabel
          }
        })
      });
    }
    popularList = countries ? countries.popularList : null;
    sortedList = countries ? countries.sortedList : null;
    // 热门国家
    if (popularList && popularList.length) {
      popularList.forEach(item => {
        const opt = {
          label: item.name,
          value: item.isoCountryCode2,
          optGroup: {
            label: popularLabel
          }
        }
        // 中国内地需添加省份
        if (item.isoCountryCode2 === this.factorySer.isoCountryCodeCN) {
          opt['children'] = regionsOpts;
        }
        countryRegionOpts.push(opt)
      });
    }
    // 全部国家
    if (sortedList && sortedList.length) {
      sortedList.forEach(item => {
        const opt = {
          label: item.name,
          value: item.isoCountryCode2,
          optGroup: {
            label: allLabel
          }
        }
        if (item.isoCountryCode2 === this.factorySer.isoCountryCodeCN) {
          opt['children'] = regionsOpts;
        }
        countryRegionOpts.push(opt)
      });
    }
    // 缓存组件需要的国家省份列表数据
    if (countryRegionOpts && countryRegionOpts.length) {
      sessionStorage.setItem(countryRegionOptsKey, JSON.stringify(countryRegionOpts));
    }
    return countryRegionOpts;
  }

  public async deleteAccount(params: any) { 
    this.factorySer.setLimitType('toast');
    const resp = await this.acctSer.deleteAcct(params);
    if(resp) {
      switch (resp.code) {
        case '0':
          this.clearCache();
          // del account clear cookie
          this.clearCookieBySDK(resp);
          this.comSubSer.refreshLoading(false);
          this.acctSer.token = null;
          await this.comActSer.deleteRouting();
          break;
        default:
          this.comSubSer.refreshLoading(false);
          this.factorySer.setSinglePop();
          break;
      }
    } else {
      this.comSubSer.refreshLoading(false);
      console.log('linit err..',resp)
    }
  }

  // 处理legacy用户信息
  handelLegacyInfo(type: 'get' | 'set' | 'clear') {
    let legInfo;
    switch (type) {
      case 'get':
        legInfo = this.rFactorySer.get('legInfo')
        if(legInfo) {
          return {
            email: Base64.decode(legInfo?.leg_eml),
            password: this.factorySer.tempDecryptCode(legInfo?.leg_ps)
          };
        } else {
          return null
        }
      case 'set':
        legInfo = {
          leg_eml: Base64.encode(this.email),
          leg_ps: this.factorySer.tempEncryptCode(this.password),
        }
        this.rFactorySer.set('legInfo', legInfo)
        break;
      case 'clear':
        sessionStorage.removeItem('legInfo');
        break;
      default:
        break;
    }
  }

  // link route action with click event class name
  public linkAction(className: string) { 
    let linkKey;
    switch (className) { 
      case 'profile-tnc':
      case 'virtual-p-pop-link':
        linkKey = 'Profile.Common.Link.TNC';
        break;
      case 'profile-policy':
        linkKey = 'Profile.Common.Link.Policy';
        break;
      case 'profile-notice':
        linkKey = 'Profile.Login.Link.ShdrNotice';
        break;
      case 'personalized-link':
        linkKey = 'Profile.EditProfile.AcctSetting.Personalization.Link';
        break;
      case 'del-acct-contact-us':
        linkKey = 'Profile.EditProfile.DeleteAcct.Link.Contact';
        break;
      case 'profile-idcard-explain':
        this.factorySer.showGuestIdCardPop = true;
        break;
      case 'del-acct-shdr-minp-item':
        linkKey = 'Profile.Common.Link.Shdr.Minip';
        break;
      default:
        break;
    }
    if (linkKey) { 
      const url = this.acpSer.getAcpText(linkKey);
      this.comActSer.routeURLCheck(url);
    }
  }

  public cacheConsent(stateList: any) {
    const selectIterms = stateList.reduce((acc, cur) => {
      acc[cur.type] = cur.checked;
      return acc;
    }, {});
    sessionStorage.setItem('selectIterms', JSON.stringify(selectIterms));
  }

  public clearCache() { 
    this.mobile = null;
    this.email = null;
    this.areaNum = '86,CN';
    this.password = '';
    this.acctSer.logInfo = {
      mobile: null,
      areaNum: null,
      email: null
    }
  }

  // SDK补全cookie
  setCookieBySDK(resp) {
    if (!this.platform.isApp() && resp?.code === '0' && resp?.data?.sdkCookieName && resp?.data?.token) {
      const { VisitorFlag, visitorId, shdrAccessToken, shdrRefreshToken } = resp?.data.sdkCookieName;
      const { accessToken, accessTokenExpiration, ttl, refreshToken, refreshTokenExpiration, refreshTtl } = resp?.data?.token;

      // accessToken
      const accessTokenValue = Base64.encode(JSON.stringify({
        accessToken,
        accessTokenExpiration: Math.floor(accessTokenExpiration / 1000), // 将后端毫秒时间戳转为秒
      }));
      this.setSingleCookie(shdrAccessToken, accessTokenValue, ttl);

      // refreshToken
      const refreshTokenValue = Base64.encode(JSON.stringify({
        refreshToken,
        refreshTokenExpiration: Math.floor(refreshTokenExpiration / 1000), // 将后端毫秒时间戳转为秒
      }));
      this.setSingleCookie(shdrRefreshToken, refreshTokenValue, refreshTtl);

      const visitorFlagValue = resp?.data?.visitorFlag;
      const visitorFlagExpireTimeValue = resp?.data?.visitorFlagExpireTime;
      // VisitorFlag
      this.setSingleCookie(VisitorFlag, visitorFlagValue, visitorFlagExpireTimeValue);

      const visitorIdValue = resp?.data?.visitorId;
      const visitorExpireTimeValue = resp?.data?.visitorExpireTime;
      // visitorId
      this.setSingleCookie(visitorId, visitorIdValue, visitorExpireTimeValue);
    }
  }

  public setSingleCookie(curKey: string, curValue: string, curTTL: number) { 
    console.log('setSingleCookie..', `curKey:${curKey}; curValue:${curValue}; curTTL:${curTTL}`);
    if (curKey && curValue && curTTL) {
      const cookieData = {
        key: curKey,
        value: curValue,
        attributes: {
          maxAge: curTTL,
          path: '/',
          domain: this.factorySer.domainUrl,
          secure: true
        }
      }
      this.acctSer.profileSdk.setCookie(cookieData);
    } else { 
      console.log('setSingleCookie fail..');
    }
  }

  // SDK清除cookie
  clearCookieBySDK(resp) {
    if (!this.platform.isApp() && resp?.code === '0') {
      const sdkDeleteCookieName = resp?.data?.sdkDeleteCookieName || null;
      if (sdkDeleteCookieName && sdkDeleteCookieName.length) {
        sdkDeleteCookieName.forEach(item => {
          const cookie = {
            key: item,
            value: '',
            attributes: {
              maxAge: 0,
              domain: this.factorySer.domainUrl,
              path: '/',
              secure: true,
            }
          }
          this.acctSer.profileSdk.setCookie(cookie);
        })
      } else {
        console.log('delete cookie list null...')
      }
    } else {
      console.log('resp err...')
    }
  }

  /**非86手机号触发校验接口，订阅该接口返回的校验结果
   * @param fu: callback function
   * @param phoneFlag: valid check phone number, default is true
   * @param nameFlag: valid check name,
   *  */ 
  public async waitValidCheck(fu: any, phoneFlag: boolean = true, nameFlag?: boolean) {
    if (this.phoneChecking && phoneFlag || nameFlag && this.nameChecking) {
      if (phoneFlag) {
        const phoneSub = this.phoneCheckedSub.subscribe((checked) => {
          if (checked && fu) {
            fu();
          }
          phoneSub.unsubscribe();
        })
      } else { 
        const nameSub = this.nameCheckedSub.subscribe((checked) => {
          if (checked && fu) {
            fu();
          }
          nameSub.unsubscribe();
        })
      }
    } else {
      fu();
    }
  }

  //get full current user name in different language
  public async setToggles(toggles: any) { 
    this.virPhoneToggle = toggles && toggles['Profile.VirtualPhone.Toggle'];
    this.loginVoiceToggle = toggles && toggles['Profile.Login.Register.Voice.Toggle'];
    this.comVoiceToggle = toggles && toggles['Profile.Common.Voice.Toggle'];
    this.thirdBindingToggle = toggles && toggles['Profile.EditProfile.ThirdBinding.Toggle'];
    if (this.platform.isApp()) { 
      this.appQRToggle = toggles && toggles['Profile.EditProfile.QR.APP.Toggle'];
    }else if (this.platform.isMiniP()) { 
      this.minipQRToggle = toggles && toggles['Profile.EditProfile.QR.MiniP.Toggle'];
    }
  }

  /*
    loginFlag=true, login & register flow
    loginVoiceToggle: control voice funcion in login & register
    comVoiceToggle: control voice function in common flow
  */
  public showCaptcha(loginFlag: boolean = false) {  
    //reset pinMode when user re-trigger captcha
    if (loginFlag && this.loginVoiceToggle || !loginFlag && this.comVoiceToggle) {  
      this.factorySer.pinMode = null;
    }
    this.showCaptchaSub.next(true);
  }

  // set aria-hidden for com-page when show popup in app accessibility mode
  public setHiddenAria(flag: boolean) { 
    if (this.platform.isApp()) { 
      const comPageEle = document.querySelector('.com-page');
      if (flag) {
        comPageEle && comPageEle.setAttribute('aria-hidden', 'true');
      } else {
        comPageEle && comPageEle.removeAttribute('aria-hidden');
      }
    }
  }

  public clearSubscribe() { 
    this.showReminderSub.unsubscribe();
    this.showForgetSub.unsubscribe();
    this.showCaptchaSub.unsubscribe();
    this.showErrorSub.unsubscribe();
    this.triggerCaptchaSub.unsubscribe();
    if(this.resendPinSub) this.resendPinSub.unsubscribe();
    if (this.sendVoicePinSub) this.sendVoicePinSub.unsubscribe();
  }

}
